import {Component} from 'react';
import '../css-files/moneyBuilder.css';
import { Button } from 'react-bootstrap';
import InvestmentTransactionHistoryCard from './investment_transaction_history_card';
import InvestmentInformationText from './datasets/investment_type_info_text';
import DropDownOptionCard from '../../shared-components/drop_down_option_card';
import setInvestmentText from './objects/set_investment_text';
import { doubleToStringMonthly } from '../../../objects/CommonUse/double_functions';
import ConfigFile from '../../../datasets/config_file';
import { setHeadersForFetch } from '../../../objects/CommonUse/set_headers_for_fetch';
import buildUrl from '../../../objects/CommonUse/build_URL';
import Config from '../../../config';
import WaitTimeSpinner from '../../shared-components/wait_time_spinner';

class InvestmentTransactionHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false, 
            gameInvestHistoryLoaded: false,
            headers: setHeadersForFetch(),
            environment: Config.dataURL.currentEnv,
            subProcess: "investmentTransactionHistory",
            waitState: false, 
            rerender: false
        };
        this.investNameOptionsArr = [];
        this.closedYearOptionsArr = [];
        this.yearFilter = "all years";
        this.nameFilter = "all investments";
        this.historyTranOld = [];
        this.addHistoryButton = true;
        this.initializeInformation();
    }

    initializeInformation(){
        this.setHeading();
        if (this.props.investInfo.historyExists === true){
            this.historyExists = true;
            const gameDateArr = (this.props.currentGameDate).split('-');
            this.historyYear = +gameDateArr[0] - +ConfigFile.investments.historyYears; 
        }
        this.selectTranHistory();
        this.determineTotalGainLoss();
        this.determineFilterOptions();
    }
     
    setHeading(){
        const investmentTextObj = setInvestmentText(this.props.investInfo.investType);
        this.headingText = investmentTextObj.headingText + "s";
        this.pluralText = investmentTextObj.investTypeText + "s";
        const informationObj = 
            InvestmentInformationText.find(elem => elem.investType === this.props.investInfo.investType);
        this.imageURL = informationObj.imageURL;
    }
     
    selectTranHistory(){
        const investType = this.props.investInfo.investType;
        this.historyTranArr = this.props.historyTranArr.filter(item => item.investType === investType);
        this.taxHistoryArr = this.props.taxHistoryArr.filter(item => item.investType === investType);
        this.historyTranOut = this.historyTranArr;
        this.taxHistoryOut = this.taxHistoryArr.filter(item => item.year === "all");
    }
   
    determineTotalGainLoss(){
        this.beforeTaxTotal = 0;
        this.totalTaxAmt = 0;
        this.afterTaxTotal = 0;
        this.taxesFound = false;
        const historyTranOut = this.historyTranOut.concat(this.taxHistoryOut);
        for (let i=0; i<historyTranOut.length; i++){
            const historyTran = historyTranOut[i];
            if (historyTran.rcdType === "tax"){
                this.taxesFound = true;
               
            }else{
                this.beforeTaxTotal += +historyTran.totalGainLoss;
            }
            this.afterTaxTotal += +historyTran.totalGainLoss;
        }
        const defaultClass = "text-right ";
        if (this.beforeTaxTotal < 0){
            this.beforeTaxClass = defaultClass + "text-danger";
        }else{
            this.beforeTaxClass = defaultClass;
        }
        if (this.afterTaxTotal < 0){
            this.afterTaxClass = defaultClass + "text-danger";
        }else{
            this.afterTaxClass = defaultClass;
        }
    }

    determineFilterOptions(){
        this.investNameOptionsArr = [];
        this.closedYearOptionsArr = [];
        let sortedHistoryTranArr = JSON.parse(JSON.stringify(this.historyTranOut));
        sortedHistoryTranArr.sort((a, b) => (a.investmentName > b.investmentName) ? 1 : -1)
        const investNameObj = {value: "all investments", selection: "no filter applied"};
        this.investNameOptionsArr.push(investNameObj);
       
        for (let i=0; i<sortedHistoryTranArr.length; i++){
            if (sortedHistoryTranArr[i].rcdType !== "tax"){
                const investmentName = sortedHistoryTranArr[i].investmentName;
                const checkInvestNameOptions = 
                    this.investNameOptionsArr.find(elem => elem.value === investmentName)
                if (!checkInvestNameOptions){
                    const investNameObj = {value: investmentName, selection: investmentName};
                    this.investNameOptionsArr.push(investNameObj);
                }
                const closeDate = sortedHistoryTranArr[i].dateClosed;
                const closeDateArr = closeDate.split('-');
                const closedYear = closeDateArr[0];
                const checkClosedYearOptions = 
                    this.closedYearOptionsArr.find(elem => elem.value === closedYear)
                if (!checkClosedYearOptions){
                    const closedYearObj = {value: closedYear, selection: closedYear};
                    this.closedYearOptionsArr.push(closedYearObj);
                }
            }
        }
        this.closedYearOptionsArr.sort((a, b) => (a.value > b.value) ? -1 : 1)
        const closedYearObj = {value: "all years", selection: "no filter applied"};
        this.closedYearOptionsArr.splice(0, 0, closedYearObj);
    }   

    //  filter by investments changed to 'all investments'.... but years has value then
    //  should revert to historyTranArr.....

    filterTransactionHistory(filterArg){
        if (!filterArg){
            this.nameFilter = "all investments";
            this.yearFilter = "all years";
        }else{
            const filterArr = filterArg.split("|");
            const filterType = filterArr[0];
            if (filterType === "investName"){
                this.nameFilter = filterArr[1];
            }else{
                this.yearFilter = filterArr[1];
            }
        }
        if (this.yearFilter === "all years" && this.nameFilter === "all investments"){
            this.historyTranOut = this.historyTranArr.concat(this.historyTranOld);
            this.taxHistoryOut = this.taxHistoryArr.filter(item => item.year === "all");
        }else{
            if (this.yearFilter === "all years"){
                this.historyTranOut = this.historyTranArr.concat(this.historyTranOld);
                this.historyTranOut = 
                    this.historyTranOut.filter(item => item.investmentName + item.rcdType
                         === this.nameFilter + "tran");
                this.taxHistoryOut = [];
            }else{
                if (this.nameFilter === "all investments"){
                    this.historyTranOut = this.historyTranArr.concat(this.historyTranOld);
                    this.historyTranOut = 
                        this.historyTranOut.filter(item => item.dateClosed.split("-")[0] === this.yearFilter);
                    this.taxHistoryOut = this.taxHistoryArr.filter(item => item.year === this.yearFilter);
                }else{
                    this.historyTranOut = this.historyTranArr.concat(this.historyTranOld);
                    this.historyTranOut = this.historyTranOut.filter(item => item.dateClosed.split("-")[0] +
                        item.investmentName + item.rcdType === this.yearFilter + this.nameFilter + "tran");
                    this.taxHistoryOut = [];
                }
            }
        }
        this.historyTranOut.sort((a, b) => (a.dateClosed + (+a.transNbr) > b.dateClosed + +(b.transNbr)) ? 1 : -1);
        this.determineTotalGainLoss();
        this.setState({rerender: !this.state.rerender});
    }

    render() {
        this.investNameOptions = this.investNameOptionsArr.map((optionsList,index) =>
            <DropDownOptionCard options={optionsList} key={index} />
        );
         this.yearOptions = this.closedYearOptionsArr.map((optionsList,index) =>
            <DropDownOptionCard options={optionsList} key={index} />
        );
        this.historyTransactionInfo =  this.historyTranOut.map((historyTrans, index) =>
            <InvestmentTransactionHistoryCard key={index} historyInfo={historyTrans} 
                 />
        );
        this.taxHistoryInfo =  this.taxHistoryOut.map((historyTrans, index) =>
            <InvestmentTransactionHistoryCard key={index} historyInfo={historyTrans} 
                 />
        );
        const defaultImgSrc = "./assets/UnlockedFeatures/" + this.imageURL;
    return <>
        <div className="mt-4 solid-line"></div>
            <div className="custom-header">
            <div className="row">
                <div className="col-sm-2 mt-2">
                       <img src={defaultImgSrc} className="card_size_thumbnail_img" alt="logo"/>
                </div>
                <div className="col-sm-1"></div>
                <div className="col-sm-8 ml-5">
                    <h4 className="ml-5 mt-4">
                        Closed Transactions for {this.headingText}
                    </h4>
                </div>
                <div className="col-sm-4">
                    {this.historyExists && 
                        <span>
                            {this.addHistoryButton ?
                                <div className="custom-button">
                                    <Button className="history-button" onClick={() => this.addGameInvestHistory()}>
                                        Load History Before {this.historyYear}
                                    </Button>
                                </div>
                            :
                                <div className="custom-button">
                                    <Button className="history-button" onClick={() => this.removeGameInvestHistory()}>
                                        Remove History Before {this.historyYear}
                                    </Button>
                                </div>
                            }
                        </span>
                    }
                </div>
                </div>
            </div>
            {this.state.waitState === true   ?
                <WaitTimeSpinner/>
            :
                null
            }
            <div className="mt-2 text-left mx-4  invest-type-text">{this.informationText}</div>
            <div>
                {this.historyTranArr.length === 0 ?
                    <div className="row">
                        <div className="col-sm-2"></div>
                        <div className="col-sm-10">
                            <div className="mt-2 text-left mx-4  invest-type-text">
                                You do not currently have any transaction history to report 
                                    for {this.headingText}. 
                            </div>
                        </div>
                    </div>
                :
                    <span>
                        <h5 className="text-center">------ Apply Filters ------</h5>
                        <div className="filter-container ml-5">
                            <div className="filter-group ml-5">
                                <label className="filter-label" htmlFor="investName">
                                    Investment Name:
                                </label>
                                <select
                                    id="investName"
                                    onChange={(val) => this.filterTransactionHistory("investName|" + val.target.value)}
                                    className="filter-select medium-select"
                                >
                                {this.investNameOptions}
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label" htmlFor="investYear">
                                    Year Closed:
                                </label>
                                <select
                                    id="investYear"
                                    onChange={(val) => this.filterTransactionHistory("closedYear|" + val.target.value)}
                                    className="filter-select small-select"
                                >
                                {this.yearOptions}
                                </select>
                            </div>
                        </div>

                        <table className="table table-hover table-no-space mt-4 invest-type-table-text">
                            <tbody>
                                <tr>
                                    <th className="text-center">Investment Name</th>
                                    <th className="text-center">Tran Type</th>
                                    <th className="text-center">Date Closed</th>
                                    <th className="text-center">Qty</th>
                                    <th className="text-center">Buy Amount</th>
                                    <th className="text-center">Sell Amount</th>
                                    <th className="text-center">Gain/Loss Amt</th>
                                </tr>
                                    {this.historyTransactionInfo}
                               {this.taxesFound ? (
                                    <>
                                        <tr>
                                            <th className="text-left" colSpan="6">Total Gain/Loss</th>
                                            <th className={this.beforeTaxClass}>
                                                {doubleToStringMonthly(this.beforeTaxTotal)}
                                            </th>
                                        </tr>

                                        {this.taxHistoryInfo}
                                    </>
                                    ) : (
                                    <tr>
                                        <th className="text-left" colSpan="6">Total Gain/Loss</th>
                                        <th className={this.afterTaxClass}>
                                        {doubleToStringMonthly(this.afterTaxTotal)}
                                        </th>
                                    </tr>
                                    )}
                               
                            </tbody>
                        </table>
                    </span>
                }
            <div className= "mx-4 mt-4">
                <b>Click on the "Investments" button to the right</b> if you wish 
                to buy or sell any units of this investment
                type.
            </div>
            </div>
            
    </>
    }

    addGameInvestHistory(){
        if (this.historyTranOld.length === 0){
            this.loadGameInvestHistory();
        }else{
            this.addInvestHistoryToArr();
        }
    }

    removeGameInvestHistory(){
        this.historyTranOut = this.historyTranArr;
        this.historyTranOut.sort((a, b) => (a.dateClosed + (+a.transNbr) > b.dateClosed + +(b.transNbr)) ? 1 : -1);
        this.determineTotalGainLoss();
        this.determineFilterOptions();
        this.addHistoryButton = true;
        this.setState({rerender: !this.state.rerender});
    }

    loadGameInvestHistory(){
        this.setState({waitState: true})
        const funcName = "loadGameInvestHistory";
        const urlParm = "?gameID=" + this.props.gameID + "&investType=" + this.props.investInfo.investType;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            { method: 'GET', headers: this.state.headers })
            .then(response => {
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.gameInvestHistory = output.body[0];
                        this.historyTranOld = this.gameInvestHistory.historyTranArr;
                        this.addInvestHistoryToArr();
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message, errorObject: urlParm};
                        this.props.processError(errorObj);
                    }
                });
            });
    }

    addInvestHistoryToArr(){
        this.historyTranOut = this.historyTranArr.concat(this.historyTranOld);
        this.historyTranOut.sort((a, b) => (a.dateClosed + (+a.transNbr) > b.dateClosed + +(b.transNbr)) ? 1 : -1);
        this.determineTotalGainLoss();
        this.determineFilterOptions();
        this.addHistoryButton = false;
        this.setState({waitState: false});
    }
        
       
}

export default InvestmentTransactionHistory;